export const SHARING_REQUESTS_KEYS = {
  sharingRequests: 'sharingRequests',
  byProjectID: 'byProjectID',
}
